import React from "react";
import { noop } from "lodash";

import { Component } from "../../../../commons/types/component";
import { IconSmallCheck } from "../../../../resources/icons";
import cn from "../../libs/class-name";
import Icon from "../Icon/Icon";
import Image from "../Image/Image";

type Size = "default" | "s";

interface Props extends Component {
  label: string;
  imageUrl: string;
  imageFallback?: React.ReactNode;
  imageWidth?: "s" | "m" | "l";
  imageAspectRatio?: number;
  size?: Size;
  active?: boolean;
  outline?: boolean;
  badge?: React.ReactElement;
  onClick?: React.EventHandler<React.MouseEvent<HTMLButtonElement>>;
}

const CheckboxListItemWithImage = ({
  classNames = [],
  label,
  imageUrl,
  imageFallback,
  imageWidth = "m",
  imageAspectRatio = 16 / 9,
  size = "default",
  active = false,
  outline = false,
  badge,
  onClick = noop
}: Props) => (
  <button
    type="button"
    aria-label={label}
    onClick={onClick}
    className={cn(
      "CheckboxListItemWithImage",
      [
        {
          active,
          outline,
          [`image-width-${imageWidth}`]: imageWidth,
          [`size-${size}`]: size
        }
      ],
      classNames
    )}
  >
    <div className="CheckboxListItemWithImage__image">
      <Image src={imageUrl} alt="" fallbackContent={imageFallback} ratio={imageAspectRatio} position="center" />
    </div>
    {!!badge && <div className="CheckboxListItemWithImage__badge">{badge}</div>}
    <div className="CheckboxListItemWithImage__checkbox">
      <Icon source={IconSmallCheck} />
    </div>
  </button>
);

export default CheckboxListItemWithImage;
